<InsuranceCasesOverview [isOneWay]="Settings.isInAny(['OneWayAdmin'])"></InsuranceCasesOverview>
